<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M4.4 5.6C4.4 3.2 5 2 8 2h6c2.166 0 3.0809.62556 3.4222 1.87668.9374.3883 1.7908.9331 2.5175 1.60789.78.72429 1.3987 1.58416 1.8209 2.5305.4221.94634.6394 1.96062.6394 2.98493 0 1.0243-.2173 2.0386-.6394 2.9849-.4222.9464-1.0409 1.8062-1.8209 2.5305-.6805.6319-1.4721 1.1498-2.3397 1.532V20h1.2c.6627 0 1.2.5373 1.2 1.2s-.5373 1.2-1.2 1.2H3.2c-.66274 0-1.2-.5373-1.2-1.2S2.53726 20 3.2 20h1.2V5.6Zm13.2 9.8571V6.54286c.2266.15783.4414.33071.6426.51754.5572.51736.9991 1.13155 1.3007 1.80751C19.8448 9.54386 20 10.2683 20 11c0 .7317-.1552 1.4561-.4567 2.1321-.3016.6759-.7435 1.2901-1.3007 1.8075-.2012.1868-.416.3597-.6426.5175ZM8.20007 5.80005c-.55228 0-1 .44771-1 1v2c0 .55228.44772 1 1 1h5.60003c.5523 0 1-.44772 1-1v-2c0-.55229-.4477-1-1-1H8.20007Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M4 22c-.55 0-1-.45-1-1s.45-1 1-1h1V6c0-2.21 1.79-4 4-4h5c1.96 0 3.59 1.40999 3.94 3.26999.25.08.5.16001.74.26001.85.36 1.62.86999 2.27 1.51999.65.65 1.17 1.42002 1.52 2.27002C22.82 10.17 23 11.08 23 12c0 .92-.18 1.83-.53 2.68-.35.85-.87 1.62-1.52 2.27-.65.65-1.42 1.17-2.27 1.52-.22.09-.45.17-.68.24V20h1c.55 0 1 .45 1 1s-.45 1-1 1H4Zm15.54-6.46c.46-.47.83-1.02 1.08-1.62.25-.61.38-1.26.38-1.92 0-.65-.13-1.31-.38-1.91-.25-.61-.62-1.16-1.08-1.62-.44-.45-.97-.79999-1.54-1.04999V16.58c.57-.25 1.1-.6 1.54-1.04ZM14 4H9c-1.1 0-2 .9-2 2v14h9V6c0-1.1-.89-2-2-2ZM8 7c0-.552.448-1 1-1h5c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1V7Zm2 2h3V8h-3v1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
